import { $t } from "../../../utils/intl";
import { handleNumberField } from "../../prefill/helpers";
import type { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { defaultToReviewString } from "../review/reviewString.helpers";
import type { TextFieldValue } from "../text/text.config";
import { NumberFieldControl } from "./NumberFieldControl/NumberFieldControl";

export const numberFieldConfig: FieldRegistryConfig<TextFieldValue> = {
  icon: "number",
  control: (props) => (
    <NumberFieldControl placeholder={$t(fieldsText.numberPlaceholder)} type="number" {...props} />
  ),
  prefill: handleNumberField,
  toReviewString: defaultToReviewString,
};
